#import "./confluence-comment-fragment.graphql"

query CommentList(
  $offset: String
  $last: Long
  $contentId: ID!
  $commentId: ID
  $inlineMarkerRef: String
) {
  comments(
    pageId: $contentId
    last: $last
    before: $offset
    contentStatus: [CURRENT]
    depth: ROOT
    # The type field below is an array which performs an OR operation on its elements
    type: [UNRESOLVED]
    commentId: $commentId
    inlineMarkerRef: $inlineMarkerRef
  ) {
    edges {
      cursor
      node {
        ...CommentFragment
        replies {
          ...CommentFragment
        }
        __typename
      }
      __typename
    }
    totalCount
    __typename
  }
}
